import { userActions } from "../store/reducers/userReducer";

export class AuthorizationService {
    static $inject = ['$http', 'api', '$q', 'store'];
    constructor($http, api, $q, store) {
        this.$http = $http;
        this.host = api.restServiceUrl;
        this.$q = $q;
        this.isAuthorized = null;
        this.store = store;
    }

    authorize() {
        return new Promise((resolve) => {
            this.isAuthorized = true;
            setTimeout(() => resolve(true), 100);
        });
    }
    getPermissions = async () => {
        const userDetailsResponse = await this.store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS });
        const userPermissionsResponse = await this.store.dispatch({
            type: userActions.GET_PERMISSIONS_FOR_USER,
            payload: { userId: userDetailsResponse.data.id }
        });
        return userPermissionsResponse;
    }

    async isProjectAdmin() {
        return (await this.getPermissions()).findIndex(item => (item.key == "Project Admin" && item.value == true)) != -1 ? true : false;
    }

    async isAdmin() {
        return (await this.getPermissions()).findIndex(item => (item.key == "Admin" && item.value == true)) != -1 ? true : false;
    }

    async isProjectManipulator() {
        return (await this.getPermissions()).findIndex(item => ((item.key == "Package Creation and Manipulation" || item.key == "Project Admin") && item.value == true)) != -1 ? true : false;
    }

    async isAuthorizedToPerformAction(action, projectId = null) {
        return await this.isAuthorizedToPerformActionWithProject(action, projectId);
    }

    async isAuthorizedToPerformActionWithProject(action, projectId = null) {
        let url = `${this.host}IsAuthorized/${action}`
        if (projectId) {
            return (await this.$http.get(`${url}/project/${projectId}`).then(resp => resp.data));
        }
        return (await this.$http.get(`${url}`).then(resp => resp.data));
    }
}



// WEBPACK FOOTER //
// ./src/services/authorizationService.js